"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _devise = require("@/api/devise");
var _qrcodejs = _interopRequireDefault(require("qrcodejs2"));
var _permission = require("@/utils/permission");
var _public = require("@/libs/public");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'index',
  data: function data() {
    return {
      grid: {
        xl: 16,
        lg: 20,
        md: 20,
        sm: 24,
        xs: 24
      },
      grid2: {
        xl: 12,
        lg: 12,
        md: 20,
        sm: 24,
        xs: 24
      },
      listActive: 0,
      tabList: ['商城首页', '自定义页面'],
      tableForm: {
        page: 1,
        limit: 10,
        name: ''
      },
      name: '',
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      frontDomain: '',
      perViewDia: {
        // 列表二维码预览
        visible: false,
        perViewUrl: ''
      },
      Qrcode: '',
      //小程序二维码
      // 用一个字符串来保存当前双击的是哪一个单元格
      currentCell: null
    };
  },
  mounted: function mounted() {
    this.frontDomain = "".concat(this.$selfUtil.getFrontDomainUrl(), "/pages/index/index");
    if ((0, _permission.checkPermi)(['platform:pagediy:list'])) this.getList();
    this.getWechatQrcode();
    this.getQRcode();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 给单元格绑定横向和竖向的index，这样就能确定是哪一个单元格
    tableCellClassName: function tableCellClassName(_ref) {
      var row = _ref.row,
        column = _ref.column,
        rowIndex = _ref.rowIndex,
        columnIndex = _ref.columnIndex;
      row.index = rowIndex;
      column.index = columnIndex;
    },
    // 获得当前双击的单元格的横竖index，然后拼接成一个唯一字符串用于判断，并赋给currentCell
    // 拼接后类似这样："1,0","1,1",
    handleName: function handleName(row, column) {
      var _this = this;
      this.currentCell = row.index + ',' + column.index;
      // 这里必须要setTimeout，因为在点击的时候，input才刚被v-if显示出来，不然拿不到dom
      setTimeout(function () {
        // 双击后自动获得焦点
        _this.$refs[row.index + ',' + column.index].focus();
      });
    },
    // 当input失去焦点的时候，隐藏input
    hideInput: function hideInput(item) {
      var _this2 = this;
      if (!item.name) {
        return this.$message.warning('模板名称不能为空');
      } else {
        this.currentCell = null;
      }
      (0, _devise.pagediyUpdatenameApi)({
        id: item.id,
        name: item.name
      }).then(function (res) {
        _this2.$message.success('编辑成功');
      });
    },
    //微信二维码
    getQRcode: function getQRcode() {
      document.getElementById('diyQrcode').innerHTML = '';
      new _qrcodejs.default('diyQrcode', {
        width: 120,
        height: 120,
        text: this.frontDomain
      });
    },
    //小程序二维码
    getWechatQrcode: function getWechatQrcode() {
      var _this3 = this;
      // env_version	默认值为："release"，要打开的小程序版本。正式版为"release"，体验版为"trial"，开发版为"develop"，仅在微信外打开时生效。
      (0, _devise.wechatQrcodeApi)({
        scene: 'id=0',
        path: 'pages/index/index',
        env_version: 'release'
      }).then(function (res) {
        _this3.Qrcode = res.code;
      });
    },
    //点击左侧菜单
    ProductNavTab: function ProductNavTab(index) {
      this.listActive = index;
    },
    //预览
    previewProtol: function previewProtol(id) {
      if (!id) return;
      this.perViewDia.perViewUrl = this.frontDomain + '?id=' + id;
      this.perViewDia.visible = true;
    },
    // 使用模板
    setHomepage: function setHomepage(id) {
      var _this4 = this;
      this.$modalSure('把该模板设为首页').then(function () {
        (0, _devise.pagediySetdefaultApi)(id).then(function (res) {
          _this4.$message.success('操作成功');
          _this4.getList();
        });
      });
    },
    // DIY 编辑首页
    handlerDiyHomePage: function handlerDiyHomePage() {
      var _this5 = this;
      (0, _devise.pagediyGetSetHome)().then(function (homePageId) {
        _this5.handlerEditDiyPage(homePageId, 'edit');
      });
    },
    // 添加
    handlerEditDiyPage: function handlerEditDiyPage(id, type) {
      var _this$$router$resolve = this.$router.resolve({
          path: "/page/design/creatDevise/".concat(id, "/").concat(type)
        }),
        href = _this$$router$resolve.href;
      window.open(href);
    },
    getList: function getList(num) {
      var _this6 = this;
      this.listLoading = true;
      this.tableForm.page = num ? num : this.tableForm.page;
      this.tableForm.name = encodeURIComponent(this.name);
      (0, _devise.pagediyListApi)(this.tableForm).then(function (res) {
        _this6.listLoading = false;
        _this6.tableData.data = res.list;
        _this6.tableData.total = res.total;
      }).then(function (res) {
        _this6.listLoading = false;
      });
    },
    // 删除
    handleDelete: function handleDelete(id, idx) {
      var _this7 = this;
      this.$modalSure('删除模板吗').then(function () {
        (0, _devise.pagediyDeleteApi)({
          id: id
        }).then(function (res) {
          _this7.$message.success('删除成功');
          (0, _public.handleDeleteTable)(_this7.tableData.data.length, _this7.tableForm);
          _this7.getList();
        });
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableForm.limit = val;
      this.getList();
    },
    pageChange: function pageChange(val) {
      this.tableForm.page = val;
      this.getList();
    }
  }
};